import React from 'react'; 
import blueIcon from '../hybridImages/BlueBulbIcon.png';
import mData from '../hybriddata/mainform.json';
 
const BlueboxEsgTxt = (props) => {

    const {textList} = props;

    const handleESGLink = () => {
        // window.location.href = mData.esgImpactHubUrl;
        window.open(mData.esgImpactHubUrl,'_blank');
    }

    return(
    <div className="row around-xs inputPair elementVisible">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
            <div className='bluebox'>
                <div>
                    <img className='upload-left-icon-size' src={blueIcon} alt='blue-bulb' />&nbsp;&nbsp;
                    <span className='bluebox-txt-ul'>{'Financing for Environmental, Social and Governance (ESG) goals include benefits such as:'}</span>
                </div>
                <div>
                    <ul className='bluebox-txt-ul'>
                    {textList.map((item, idx) => (
                        <li key={idx}>{item}</li>
                    ))}
                    </ul>
                </div>
                <div className='bb-txt-link'>
                    <span>{'Learn more about setting ESG business goals at the'}</span>&nbsp;
                    <span className='txtBlue' style={{cursor:'pointer'}} onClick={handleESGLink}>{'myimpact SME Hub.'}</span>
                </div>
            </div>
        </div>
    </div>
    )
}

export default BlueboxEsgTxt